/**
 * Installation video — click-to-play lite embed. Swaps the static thumbnail
 * for a Vimeo iframe only after the visitor clicks play (no tracking, no
 * autoplaying iframe on page load). Ported from PDPVideo.tsx.
 */
(function () {
  function parseVimeoEmbedSrc(url) {
    try {
      var u = new URL(url);
      if (u.hostname.indexOf('vimeo.com') === -1) return null;
      var parts = u.pathname.split('/').filter(Boolean);
      var id = parts[0];
      var hash = parts[1];
      if (!id) return null;
      var base = 'https://player.vimeo.com/video/' + id + '?autoplay=1&title=0&byline=0&portrait=0';
      return hash ? base + '&h=' + hash : base;
    } catch (e) {
      return null;
    }
  }

  function initVideo(section) {
    var frame = section.querySelector('[data-mel-video-frame]');
    var playButton = section.querySelector('[data-mel-video-play]');
    var vimeoUrl = section.getAttribute('data-mel-vimeo-url');
    if (!frame || !playButton || !vimeoUrl) return;
    var embedSrc = parseVimeoEmbedSrc(vimeoUrl);
    if (!embedSrc) return;

    playButton.addEventListener('click', function () {
      var iframe = document.createElement('iframe');
      iframe.src = embedSrc;
      iframe.title = 'Installation video';
      iframe.allow = 'autoplay; fullscreen; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.className = 'absolute inset-0 h-full w-full';
      frame.innerHTML = '';
      frame.appendChild(iframe);
    });
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('[data-mel-video-section]')).forEach(initVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
